import { Directive, forwardRef, Attribute } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appValidateEqual][formControlName],[appValidateEqual][formControl],[appValidateEqual][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualsValidatorDirective), multi: true }
  ]
})
export class EqualsValidatorDirective implements Validator {
  constructor(@Attribute('appValidateEqual') public appValidateEqual: string) {}

  validate(c: AbstractControl): { [key: string]: any } | null {
    const v = c.value;
    const e = c.root.get(this.appValidateEqual);

    if (e && v !== e.value) {
      return { appValidateEqual: false };
    }

    return null;
  }
}